import styled from "styled-components";
import { Link } from "react-router-dom";

/**
 * Wrapper principal do cabeçalho (Mobile)
 */
export const HeaderWrapperMobile = styled.header.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop as string),
})<{ isVisible: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 100;
  display: flex;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.3s ease;
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0)" : "translateY(-100%)"};

  & > div {
    justify-content: space-between;
    display: flex;
    width: 100%;
  }
`;

/**
 * Wrapper do logotipo
 */
export const LogoWrapperMobile = styled.a`
  width: fit-content;
  height: ${({ theme }) => theme.spacing(4)};
  text-align: left;
  flex: 0 0 auto;
  display: inline-flex;

  svg {
    height: 100%;
    width: auto;
  }
`;

export const MobileHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const MobileLoginAction = styled.a`
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  text-decoration: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 3px;
  }
`;

export const MobileProfileAction = styled(Link)`
  width: ${({ theme }) => theme.spacing(4)};
  height: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.colors.mediumBlue};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }

  svg path {
    fill: currentColor;
  }

  &:focus-visible {
    border-radius: ${({ theme }) => theme.borderRadius.full};
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 3px;
  }
`;

/**
 * Wrapper do botão de toggle do menu
 */
export const MobileMenuToggleMobile = styled.button`
  color: ${({ theme }) => theme.colors.vividBlue};
  font-size: ${({ theme }) => theme.fontSizes.md};
  align-items: center;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
`;

/**
 * Wrapper da navegação
 */
export const MobileNavWrapperMobile = styled.nav`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  display: flex;
  z-index: 1000;
  width: 100%;
  left: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing(1.5)};
  }

  div > ul {
    align-items: flex-start;
    flex-direction: column;

    li {
      color: ${({ theme }) => theme.colors.disabledGray};
      font-weight: ${({ theme }) => theme.fontWeights.extraLight};
      font-size: ${({ theme }) => theme.fontSizes.md};
      border-bottom: 1.5px solid ${({ theme }) => theme.colors.lightGray};
      width: 100%;
      border-radius: 0;
    }

    li:last-child {
      border-bottom: none;
    }
  }
`;

/**
 * Wrapper da lista de itens do menu
 */
export const MenuListWrapperMobile = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
`;
